import React from "react";
import FondoCiudad from "../images/fondociudad.png";
import ActividadDinamica from "../images/actividaddinamica.png";
import Pupiletras from "../images/pupiletras.png";
import Dinamica from "../images/dinamica.png";
import NotaDinamica from "../images/notadinamica.png";

import { Helmet } from "react-helmet";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  contentLamina2: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
    background: theme.palette.secondary.main,
    padding: "2em",
  },
  actividadFondo: {
    backgroundImage: "url(" + FondoCiudad + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: 600,
    width: "100%",
    marginTop: 40,
    textAlign: "right",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    "& p": {
      lineHeight: 1.5,
      maxWidth: 400,
    },
    marginBottom: "4em",
  },
  actividad: {
    background: "#6a2c9138",
    border: "6px solid " + theme.palette.purple.main,
    "& p": {
      marginLeft: "1em",
    },
    marginBottom: "4em",
  },
  options: {
    borderBottom: "1px solid #ccc",
  },
  option: {
    color: theme.palette.blue.main,
    textAlign: "right",
  },
  actividadContent: {
    maxWidth: 800,
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
}));

const Lamina2 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 8: La dinámica de la ciudad"
        meta={[
          {
            property: "og:title",
            content: "Lámina 8: La dinámica de la ciudad",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Las ciudades se caracterizan por concentrar a una gran cantidad de personas.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="8" color="primary" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="LA DINÁMICA DE LA CIUDAD" color="primary" />
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={8} xs={12}>
            <p>
              Las ciudades se caracterizan por concentrar a una gran cantidad de
              personas. Este elevado número de habitantes requiere de muchos
              recursos para alimentarse, vestirse y cubrir sus necesidades
              básicas.
            </p>
            <p>
              Para satisfacer estas necesidades y ofrecer, además, servicios
              como agua potable, desagüe, electricidad y transporte, se requiere
              de una importante transformación del territorio. Por eso, en las
              ciudades podemos encontrar edificios, grandes avenidas, mercados,
              centros comerciales, fábricas y mucho más.
            </p>
          </Grid>
          <Grid item lg={4} xs={12}>
            <img src={Dinamica} alt="Dinámica ciudad" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="primary" />
        <p>
          <strong>Une la descripción con la imagen que corresponda.</strong>
        </p>
        <img src={ActividadDinamica} alt="actividad" />
        <p style={{ color: "#0072bc" }}>
          <strong>
            Además, para que la vida en las ciudades sea ordenada y equitativa,
            es muy importante el trabajo conjunto de los ciudadanos, ciudadanas
            y autoridades.
          </strong>
        </p>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <div className={classes.actividadFondo}>
          <Grid container className={classes.root} spacing={2} justify="center">
            <Grid item lg={6} md={6} xs={12}>
              <TitleSmall title="LA VIDA EN LAS CIUDADES" color="primary" />
              <p>
                Buena parte de la población peruana vive hoy en ciudades. Estas
                acogen a una gran diversidad de personas con sus costumbres,
                tradiciones, lenguas y actividades económicas, y son un
                verdadero espacio de encuentro.
              </p>
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <img src={NotaDinamica} alt="Nota" />
            </Grid>
          </Grid>
        </div>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina2}>
        <Actividad color="primary" />
        <p>
          <strong>Ubica en el pupiletras las siguientes palabras:</strong>
        </p>
        <img src={Pupiletras} alt="actividad" />
        <p>
          <strong>
            Conversa con alguien de tu familia, y escribe o graba tu respuesta
            en audio o video: ¿qué compromisos debemos asumir todas y todos los
            ciudadanos para el uso de los espacios públicos en las ciudades de
            hoy en adelante?
          </strong>
        </p>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/06/Ciudadanía-Activa-Lámina-8.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          color="primary"
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 8: La dinámica de la ciudad'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="El campo y la ciudad"
        anteriorEnlace="/lamina-1-7"
        siguiente="Recursos naturales del Perú"
        siguienteEnlace="/lamina-1-9"
      />
    </>
  );
};

export default Lamina2;
